import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { AppState } from '../../../store/reducers/root';
import { isConnected } from '../../../store/selectors/connection';
import { getAuthenticated } from '../../../store/selectors/session';
import { AuthResult } from '../../../store/slices/session';

import ConnectionIndicator, { ConnectionStatus } from './ConnectionIndicator';

const mapStateToProps = (state: AppState) => {
  const authenticated = getAuthenticated(state);
  const connected = isConnected(state);

  const connectionStatus: ConnectionStatus = connected
    ? authenticated === AuthResult.IN_PROGRESS
      ? ConnectionStatus.IN_PROGRESS
      : ConnectionStatus.CONNECTED
    : ConnectionStatus.DISCONNECTED;

  return {
    connectionStatus,
  };
};

const connector = connect(mapStateToProps);

export type ConnectionIndicatorContainerProps = ConnectedProps<
  typeof connector
>;

export default connector(ConnectionIndicator);
